import { render, staticRenderFns } from "./TheTransactionsHistoryPage.vue?vue&type=template&id=363c1162&scoped=true"
import script from "./TheTransactionsHistoryPage.vue?vue&type=script&lang=js"
export * from "./TheTransactionsHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./TheTransactionsHistoryPage.vue?vue&type=style&index=0&id=363c1162&prod&lang=scss&scoped=true"
import style1 from "./TheTransactionsHistoryPage.vue?vue&type=style&index=1&id=363c1162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c1162",
  null
  
)

export default component.exports